import { render, staticRenderFns } from "./QueryDB.vue?vue&type=template&id=723443ea&scoped=true"
import script from "./QueryDB.vue?vue&type=script&lang=js"
export * from "./QueryDB.vue?vue&type=script&lang=js"
import style0 from "./QueryDB.vue?vue&type=style&index=0&id=723443ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723443ea",
  null
  
)

export default component.exports